import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import BottomSheet from "@/components/Modals/BottomSheet.vue";
import EditNumberDrinks from "@/components/Form/EditNumberDrinks.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalNumberDrinks',
  props: {
    dialogId: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomSheet, {
    "out-side-closable": true,
    "all-draggable": false,
    "dialog-id": props.dialogId
  }, {
    default: _withCtx(() => [
      _createVNode(EditNumberDrinks, { "display-errors": true })
    ]),
    _: 1
  }, 8, ["dialog-id"]))
}
}

})